import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // A blank page is much harder to debug than a visible error - this
    // is intentionally loud in the console.
    console.error("[AppErrorBoundary] caught render error", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="p-6 text-center flex flex-col gap-3 items-center justify-center h-screen">
          <p className="text-lg font-bold">حدث خطأ غير متوقع</p>
          <p className="text-tg-hint text-sm break-all">{this.state.error.message}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg bg-tg-button text-tg-buttonText"
          >
            إعادة المحاولة
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
